import { twMerge } from "tailwind-merge";

import CloseButton from "components/layout/CloseButton";
import DeleteButton from "components/layout/DeleteButton";
import DropDownMenu from "components/layout/dropdowns/DropDownMenu";
import FunctionalButton from "components/layout/FunctionalButton";

import { LandmarkTypesNames } from "lib/consts/navigation/map";

import { ReactComponent as WaypointIcon } from "assets/svgs/navigation/Location.svg";

const EditLandmarkPanel = ({ className = "", landmark, setLandmark }) => {
    return (
        <div className={twMerge("flex h-fit w-80 rounded-r5 bg-black90 px-6 py-3", className)}>
            <CloseButton className="absolute right-6" onClick={() => setLandmark(null)} />
            <div className="flex h-full w-full flex-col items-center space-y-5">
                <p className="text-h3">Landmark</p>
                <div className="flex w-full flex-col items-center justify-start space-y-4">
                    <div className="flex w-full  items-center justify-between">
                        <p className="text-h5">Name</p>
                        <input
                            className="text-h5 w-50 rounded-r3 px-2 py-1"
                            type="text"
                            disabled={true}
                            value={landmark.name}
                        />
                    </div>
                    <div className="flex w-full  items-center justify-between">
                        <p className="text-h5">Type</p>
                        <DropDownMenu
                            className="w-50 bg-black70"
                            value={LandmarkTypesNames[landmark.type]}
                            dropDownOptions={Object.values(LandmarkTypesNames)}
                            onSelect={(selectedOption) => {
                                setLandmark((prev) => ({
                                    ...prev,
                                    type:
                                        Object.keys(LandmarkTypesNames).find(
                                            (key) => LandmarkTypesNames[key] === selectedOption
                                        ) || landmark.type,
                                }));
                            }}
                        />
                    </div>
                </div>
                <div className="just flex w-full flex-col items-start justify-start space-y-2">
                    <p className="text-h5">Robot Facing</p>
                    {/* This is for demo version */}
                    <div className="flex h-40 w-full flex-col items-center justify-center rounded-r5 bg-neutral-50">
                        <div className="flex h-12 w-12 flex-col items-center justify-center rounded-full bg-primary">
                            <WaypointIcon className="w-8" />
                        </div>
                    </div>
                </div>
                <div className="flex w-full  items-center justify-between">
                    <DeleteButton
                        showIcon={false}
                        onClick={() => {
                            console.log("Delete");
                            setLandmark(null);
                        }}
                    />
                    <FunctionalButton
                        className="button"
                        title="Save"
                        onClick={() => {
                            console.log("Save");
                            setLandmark(null);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default EditLandmarkPanel;
